"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRequestHeader = exports.CustomHttpHeader = void 0;
var CustomHttpHeader;
(function (CustomHttpHeader) {
    CustomHttpHeader["OrganizationUid"] = "X-Wranggle-Account";
    CustomHttpHeader["OrgApiKey"] = "X-Wranggle-Api-Key";
})(CustomHttpHeader = exports.CustomHttpHeader || (exports.CustomHttpHeader = {}));
var ServiceRequestHeader;
(function (ServiceRequestHeader) {
    ServiceRequestHeader["MultipleHmacSignatures_NonBearer"] = "X-Hmac-Signatures";
})(ServiceRequestHeader = exports.ServiceRequestHeader || (exports.ServiceRequestHeader = {}));
//# sourceMappingURL=request-headers.js.map